/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_RenewInputs */

const en_recovery_codes_renew = /** @type {(inputs: Recovery_Codes_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new codes`)
};

const de_recovery_codes_renew = /** @type {(inputs: Recovery_Codes_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Codes erstellen`)
};

/**
* | output |
* | --- |
* | "Create new codes" |
*
* @param {Recovery_Codes_RenewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_renew = /** @type {((inputs?: Recovery_Codes_RenewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_RenewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_renew(inputs)
	return en_recovery_codes_renew(inputs)
});